import { VerifyPassportComponent } from './verify-passport/verify-passport.component';
import { AnonymousVerifyPassportComponent } from './pages/anonymous-verify-passport/anonymous-verify-passport.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthCallbackComponent} from './auth-callback/auth-callback.component';
import {MsalGuard} from '@azure/msal-angular';
import {CanActivateGuard} from './auth-guard';
import {AuthLayoutComponent} from "./layouts/auth-layout/auth-layout.component";
import {PortalLayoutComponent} from "./layouts/portal-layout/portal-layout.component";
import {RegistrationLandingComponent} from "./pages/registration/registration-landing/registration-landing.component";
import {RegistrationFormComponent} from "./pages/registration/registration-form/registration-form.component";
import {OrganizationComponent} from "./pages/organization/organization.component";
import {ContactComponent} from "./pages/contact/contact.component";
import {AuthredirectComponent} from "./pages/authredirect/authredirect.component";

import {ApplicationComponent} from "./pages/applications/application/application.component";
import {ApplicationDetailComponent} from "./pages/applications/application-detail/application-detail.component";
import {ApplicationReportComponent} from "./pages/applications/application-report/application-report.component";
import {
  EmergencyGrantApplicationComponent
} from "./pages/projects/emergency-grant-application/emergency-grant-application.component";
import {QuestionAndAnswerComponent} from "./pages/question-and-answer/question-and-answer.component";
import {RegistrationResultComponent} from "./pages/registration/registration-result/registration-result.component";
import {RoleBasedGuard, Roles} from "./role-based.guard";
import {UnauthorizedComponent} from "./pages/unauthorized/unauthorized.component";
import {PaymentInfoComponent} from "./pages/organization/payment-info/payment-info.component";
import {ExternalContactComponent} from "./pages/external-contact/external-contact.component";
import {
  ExternalPaymentinfoComponent
} from "./pages/external-contact/external-paymentinfo/external-paymentinfo.component";
import {
  ExternalActiveAssignmentComponent
} from "./pages/external-active-assignment/external-active-assignment.component";
import {
  ExternalActiveAssitnmentDetailComponent
} from "./pages/external-active-assitnment-detail/external-active-assitnment-detail.component";
import { PassportVerifiedGuard } from "./passport-verified.guard";
import { AccountLockRedirectComponent } from "./pages/account-lock-redirect/account-lock-redirect.component";
import { LoginFailedComponent } from "./pages/login-failed/login-failed.component";
import { AccountDeactivatedComponent } from "./pages/account-deactivated/account-deactivated.component";


const routes: Routes = [
  {path: 'contact-verify-passport', component: AnonymousVerifyPassportComponent},
  {path: 'contact-verify-passport/:guid', component: AnonymousVerifyPassportComponent},
  { path: 'verify-passport', component: VerifyPassportComponent, canActivate: [CanActivateGuard, MsalGuard] },
  {path: '', redirectTo: '/organization', pathMatch: 'full'},
  {path: 'authredirect', component: AuthredirectComponent},
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "registration",
        component: RegistrationLandingComponent
      },
      {
        path: "registration-form",
        component: RegistrationFormComponent
      },
      {
        path: "registration-result",
        component: RegistrationResultComponent
      },
      {
        path: "login",
        loadChildren: () => import('./layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule)
      }
    ]
  },
  {
    path: "",
    component: PortalLayoutComponent,
    canActivate: [CanActivateGuard, MsalGuard],
    children: [
      {
        path: "organization",
        component: OrganizationComponent
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },
      {
        path: "contact",
        component: ContactComponent
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },
      {
        path: "payment-info",
        component: PaymentInfoComponent,
        canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },
      {
        path: "settings", loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
        canActivate: [PassportVerifiedGuard]
      },
      {
        path: "funding-opportunities", loadChildren: () => import('./pages/projects/projects.module').then(m => m.ProjectsModules)
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },
      {
        path: "funding-opportunities/emergency/:appid", component: EmergencyGrantApplicationComponent
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      }, {
        path: "FAQ", component: QuestionAndAnswerComponent
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },
      {
        path: "applications", component: ApplicationComponent
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },
      {
        path: "applications/details/:appid", component: ApplicationDetailComponent
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },

      {
        path: "applications/report/:id", component: ApplicationReportComponent
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },
      {
        path: "contracts", loadChildren: () => import('./pages/contracts/contracts.module').then(m => m.ContactsModules)
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      },
      {
        path: "documentlibrary",
        loadChildren: () => import('./pages/documentlibrary/documentlibrary.module').then(m => m.DocumentLibraryModules),
        canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.INTERNAL]}
      }
      ,
      {
        path: "external-contact",
        component: ExternalContactComponent,
        canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.EXTERNAL]}
      }
      ,
      {
        path: "external-payment-info",
        component: ExternalPaymentinfoComponent,
        canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.EXTERNAL]}
      },
      {
        path: "external-active-assignment",
        component: ExternalActiveAssignmentComponent,
        canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.EXTERNAL]}
      },
      {
        path: "external-active-assignment/:id",
        component: ExternalActiveAssitnmentDetailComponent
        , canActivate: [RoleBasedGuard, PassportVerifiedGuard]
        , data: {roles: [Roles.EXTERNAL]}
      },]
  },
  {path: 'auth-callback', component: AuthCallbackComponent, canActivate: [CanActivateGuard, MsalGuard]},
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: 'account-lock-redirect',
    component: AccountLockRedirectComponent,
  },
  // MSAL's loginFailedRoute. No guard: the user has no working session by the time they land here.
  {
    path: 'login-failed',
    component: LoginFailedComponent,
  },
  // No guard: the account is valid in B2C but barred from the portal, so every shell route would
  // simply bounce it somewhere else.
  {
    path: 'account-deactivated',
    component: AccountDeactivatedComponent,
  }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
